import React from 'react';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import TableComponent from '../../../../Component/TableComponent/TableComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { getRoutePathname } from '../../../../Handler/RouteHandler';
import { IconButton, Tooltip } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import Swal from "sweetalert2";
import { TableReload } from '../../../../Reducer/TableReducer/TableSlice';
import { dispatch } from '../../../../App';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';

function AdministratorUserList(props) {
    const [loading, setLoading] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const navigate = useNavigate();
    const columns = [
        {
            name: "id",
            label: "Référence",
            options: { filter: true, sort: true }
        },
        {
            name: "lastname",
            label: "Nom",
            options: { filter: true, sort: true }
        },
        {
            name: "firstname",
            label: "Prénom",
            options: { filter: true, sort: true }
        },
        {
            name: "email",
            label: "Email",
            options: { filter: true, sort: true }
        },
        {
            name: "createdAt",
            label: "Date de création",
            options: { filter: true, sort: true }
        },
        {
            name: "role",
            label: "Rôle",
            options: { filter: false, sort: false }
        },
        {
            name: "action",
            label: "Action",
            options: { filter: false, sort: false }
        }
    ];
    React.useEffect(() => {
        setBreadcrumbs({
            title: 'Administrateur',
            context: 'Liste des utilisateurs',
            description: '',
            links: []
        });
        setTimeout(() => {
            setLoading(false);
        }, 1500);
    }, []);

    const getAction = (row) => {
        return (
            <>
                <div style={{ display: 'flex' }}>
                    <Tooltip title={"Éditer"} placement="left" arrow>
                        <IconButton
                            onClick={() => {
                                navigate(getRoutePathname('administrator_user', { id: row.id }))
                            }}>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Supprimer"} placement="left" arrow>
                        <IconButton
                            onClick={() => {
                                let username = row.lastname + ' ' + row.firstname;
                                Swal.fire({
                                    title: "Êtes-vous sûr de vouloir supprimer " + username + " ?",
                                    text: "",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#87bba4",
                                    cancelButtonColor: "var(--greytext)",
                                    confirmButtonText: "Confirmer",
                                    cancelButtonText: "Annuler",
                                    reverseButtons: true,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        ApiHandler.delete(
                                            {
                                                route: "administrator_user_delete",
                                                params: { id: row.id },
                                            },
                                            (response) => {
                                                if (response.status === 200) {
                                                    dispatch(TableReload("administrator_user_list"));
                                                    dispatch(
                                                        SnackbarOpen({
                                                            text: "Utilisateur supprimé avec succès",
                                                            variant: "success",
                                                        }),
                                                    );
                                                } else {
                                                    dispatch(
                                                        SnackbarOpen({
                                                            text:
                                                                response.error && response.error.message
                                                                    ? response.error.message
                                                                    : "Une erreur inattendu s'est produite.",
                                                            variant: "error",
                                                        }),
                                                    );
                                                }
                                            },
                                        );
                                    }
                                });
                            }}>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </div>
            </>
        );
    };

    return (
        <ContentViewComponent loading={loading} breadcrumbs={breadcrumbs}>
            <TableComponent
                id={'administrator_user_list'}
                title={'Utilisateurs'}
                mobileMode={'cards'}
                columns={columns}
                actionFirst={{
                    label: "Ajouter un utilisateur admin",
                    onClick: () => { navigate(getRoutePathname('administrator_user', { id: 'add' })) },
                }}
                promiseData={(resolve) => {
                    ApiHandler.get({ route: 'administrator_user_list' },
                        (response) => {
                            if (response.status === 200) {

                                let data = response.data;
                                for (let index in data) {
                                    data[index].action = getAction(data[index]);
                                    data[index].createdAt = data[index].createdAt ? moment(data[index].createdAt).format('ll') : '-';
                                }
                                resolve(data);
                            } else {
                                resolve([]);
                            }
                        });
                }}
            />
        </ContentViewComponent>
    );
}

export default AdministratorUserList;